import React, {Component} from 'react';
import ApiService from './ApiService';

/**
 * List of users.
 *
 * @class      UsersList (name)
 */
class UsersList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      addUserModal: {
        isOpen: false,
        userType: `User`,
      },
      admins: [],
      temples: [],
      adminLoading: true,
      userLoading: true,
    };

    // fetch admins
    ApiService.loadJSON(__API_URL__ + `/admin/admins`)
      .then(admins => {

        this.setState({
          admins,
          adminLoading: false,
        });
      });

    // fetch users
    ApiService.loadJSON(__API_URL__ + `/admin/temple`)
      .then(usersData => {

        this.setState({
          temples: usersData,
          userLoading: false,
        });
      });
  }

  componentWillMount() {

  }

  /**
   * Opens an add user modal.
   *
   * @param      {String}  userType  The user type
   * @param      {Object}  temple    The temple
   */
  openAddUserModal(userType, temple) {
    document.getElementById(`add-user-email`).value = ``;
    this.setState({
      addUserModal: {
        isOpen: true,
        userType,
        temple,
      },
    });
  }

  /**
   * Closes an add user modal.
   */
  closeAddUserModal() {
    this.setState({
      addUserModal: {
        isOpen: false,
        userType: `User`,
        temple: undefined,
      },
    });
  }

  /**
   * Opens a modal to add admin user.
   */
  openModalForAdmin() {
    this.openAddUserModal(`Admin`);
  }

  /**
   * Opens a modal to add user
   *
   * @param      {<type>}  temple  The temple
   * @return     {<type>}  { description_of_the_return_value }
   */
  openModalForUser(temple) {
    return () => {
      this.openAddUserModal(`User`, temple);
    };
  }

  /**
   * Adds an user.
   *
   * @param      {object}  temple  The temple
   */
  addUser(temple) {

    let email = document.getElementById(`add-user-email`).value;

    if (!email) {
      alert(`Email can't be blank`);
      return;
    }

    ApiService.loadJSON(__API_URL__ + `/admin/${temple.id}/users`, `post`, {email})
      .then(() => {
        const temples = this.state.temples;
        const templeId = temple.id;
        const templeToUpdate = temples.find(temple => temple.id === templeId);

        templeToUpdate.uploaders = templeToUpdate.uploaders || [];
        templeToUpdate.uploaders.push({email, name: email, role: `uploader`});
        this.setState();
        this.closeAddUserModal();
      });
  }

  /**
   * Removes an user.
   */
  removeUser(event, temple, email) {
    event.stopPropagation();
    var result = confirm(`Are you sure you want to remove the user?`);
    if (result) {
      ApiService.loadJSON(__API_URL__ + `/admin/${temple.id}/users`, `delete`, {email})
        .then(() => {
          const temples = this.state.temples;
          const templeId = temple.id;
          const templeToUpdate = temples.find(temple => temple.id === templeId);
          const userToRemove = templeToUpdate.uploaders.findIndex(uploader => uploader.email === email);
          templeToUpdate.uploaders.splice(userToRemove, 1);
          this.setState();
        });
    }
  }

  render() {

    let admins = this.state.admins;
    let temples = this.state.temples;
    let modalOpenClass = this.state.addUserModal.isOpen ? ` in show ` : ` hidden `;

    return (
      <div className="dashboard-users-cont container-fluid">

        {/* Add user modal */}
        <AddUserModal
          modalOpenClass={modalOpenClass}
          userType={this.state.addUserModal.userType}
          temple={this.state.addUserModal.temple}
          closeModalAction={this.closeAddUserModal.bind(this)}
          addUser={this.addUser.bind(this, this.state.addUserModal.temple)} />

        {/* user access details box for temple */}
        <TempleUsersCard
          temple={{name: `Admins`}}
          users={admins}
          openAddUserAction={this.openModalForAdmin.bind(this)}
          loading={this.state.adminLoading} />

        {
          temples.map(temple => (
            <TempleUsersCard
              key={temple.id}
              temple={temple}
              users={temple.uploaders}
              removeUser={this.removeUser.bind(this)}
              openAddUserAction={this.openModalForUser(temple)}
              loading={this.state.userLoading} />
          ))
        }

      </div>
    );
  }
}

/**
 * { user access details box for temple }
 *
 * @param      {Object}  props   The properties
 */
const TempleUsersCard = props => (
  <div className="admin-users-cont users-cont row">
    <div className="header row">
      <div className="temple-name col-xs-10">{props.temple.name}</div>
      <div className="add-user col-xs-2" hidden={props.temple.name === `Admins`} onClick={props.openAddUserAction} >
        <span className="fa fa-plus"></span>
      </div>
    </div>

    <div className="user-emails-cont">
      {
        props.loading && <div className="loader dark smaller"></div>
      }
      {
        !props.loading && 
          props.users.map(user => (
            <div key={user.email} className="user-email-cont row">
              <span className="user-email col-xs-9 col-xs-offset-1">{user.email}</span>
              <span className="user-delete col-xs-2"
                hidden={props.temple.name === `Admins`}
                onClick={event => props.removeUser(event, props.temple, user.email)}>
                <span className="fa fa-trash"></span>
              </span>
            </div>
          ))
      }
    </div>
  </div>
);

/**
 * User modal.
 *
 * @param      {Object}  props   Modal properties
 */
const AddUserModal = props => (
  <div>
    <div className={`modal-backdrop ` + props.modalOpenClass} onClick={props.closeModalAction}></div>
    <div className={`modal add-user-modal ` + props.modalOpenClass} tabIndex="-1">
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <button type="button" className="close" onClick={props.closeModalAction} >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 className="modal-title">
              Add New {props.userType} {props.temple && `for ${props.temple.name} Temple`}
            </h4>
          </div>
          <div className="modal-body">
            <div className="form-group">
              <label htmlFor="new-temple-name">Enter user email address</label>
              <input type="email" className="form-control" id="add-user-email" placeholder="Email" />
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-default"
              onClick={props.closeModalAction}>
              Close
            </button>
            <button type="button" className="btn btn-primary" onClick={props.addUser}>Add</button>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default UsersList;



// WEBPACK FOOTER //
// ./js/UsersList.js